export default __webpack_public_path__ + "dim-903595.json";